import React from 'react'
import Checkbox from '../checkbox'
import store from '../../state/store'

class RequestPlacementPosition extends React.Component {

  onToggle = () => {
    store.emit('ui:request_placement:toggle_position', this.props.tutoring_job_position.id)
  }

  render() {
    return (
      <Checkbox 
        name={this.props.tutoring_job_position.subject_name} 
        value='selected' 
        checked={this.props.selected} 
        onChange={this.onToggle} 
        label_weight={"normal"} 
      />
    )
  }
}

export default RequestPlacementPosition
